export const aiAvatarState = {
	selectAvatar: null,
	selectSound: null,
	showModal: false,
	loading: false,
	error: null,
	intervalId: null,
	enableInerval: false,
};

export const aiAvatarReducer = (state, action) => {
	switch (action.type) {
		case "setAvatar":
			return { ...state, selectAvatar: action.value };
		case "setSound":
			return { ...state, selectSound: action.value };
		case "setModal":
			return { ...state, showModal: action.value };
		case "setLoading":
			return { ...state, loading: action.value };
		case "setError":
			return { ...state, error: action.value };
		case "setInterValId":
			return { ...state, intervalId: action.value };
		case "setEnableInerval":
			return { ...state, enableInerval: action.value };
		default:
			return state;
	}
};


export class SetAIAvatarFunction {
	constructor(dispatch) {
		this.dispatch = dispatch;
		this.setAvatar = this.setAvatar.bind(this);
		this.setSound = this.setSound.bind(this);
		this.setModal = this.setModal.bind(this);
		this.setLoading = this.setLoading.bind(this);
		this.setAvatarError = this.setAvatarError.bind(this);
		this.setInterValId = this.setInterValId.bind(this);
		this.setEnableInerval = this.setEnableInerval.bind(this);
	}

	setEnableInerval(value) {
		this.dispatch({ type: 'setEnableInerval', value: value });
	}

	setAvatar(value) {
		this.dispatch({ type: 'setAvatar', value: value });
	}

	setSound(value) {
		this.dispatch({ type: 'setSound', value: value });
	}

	setModal(value) {
		this.dispatch({ type: 'setModal', value: value });
	}

	setLoading(value) {
		this.dispatch({ type: 'setLoading', value: value });
	}

	setInterValId(value) {
		this.dispatch({ type: 'setInterValId', value: value });
	}

	setAvatarError(value) {
		this.dispatch({ type: 'setError', value: value });
	}
}
